/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{__decorate as s}from"tslib";import{subclass as r}from"../../../core/accessorSupport/decorators.js";import e from"../../analysis/AnalysisView.js";let i=class extends e{};i=s([r("esri.views.2d.analysis.AnalysisView2D")],i);export{i as default};
